import { DateRange } from '../components/Filters/DashboardRange'
import moment from 'moment'

export const parseDate = (dateRange)  => {
  if (dateRange === DateRange.Today) {
    return {
      startAt: moment().startOf('day'),
      endAt: moment()
    }
  } else if (dateRange === DateRange.Yesterday) {
    return {
      startAt: moment().add(-1, 'day').startOf('day'),
      endAt: moment().add(-1, 'day').endOf('day'),
    }
  } else if (dateRange === DateRange.Week) {
    return {
      startAt: moment().subtract(7, 'days').startOf('day'),
      endAt: moment().endOf('day')
    }
  } else {
    return {
      startAt: moment().startOf('month'),
      endAt: moment()
    }
  }
}